// import React, { useState } from 'react';
// import axios from 'axios';
// import { Box, FormControl, InputLabel, OutlinedInput, FormControlLabel, Checkbox, Select, MenuItem, Button, Typography } from '@mui/material';

// const CarDetailForm = () => {
//     const [carDetail, setCarDetail] = useState({
//         Id: '',
//         Name: '',
//         Manufacturer: '',
//         Type: '',
//         Capacity: '',
//         PerDay: '',
//         IsPopular: false,
//         IsRecommended: false,
//         TravelType: [],
//         VehicleType: []
//     });

//     const handleChange = (e) => {
//         const { name, value, type, checked } = e.target;
//         setCarDetail((prevState) => ({
//             ...prevState,
//             [name]: type === 'checkbox' ? checked : value
//         }));
//     };

//     const handleMultiChange = (e) => {
//         const { name, value } = e.target;
//         setCarDetail((prevState) => ({
//             ...prevState,
//             [name]: typeof value === 'string' ? value.split(',') : value
//         }));
//     };
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const response = await axios.post('https://carrentalbackend.dockyardsoftware.com/api/CarDetail', carDetail, {
//                 headers: { 'Content-Type': 'application/json' },
//             });
//             alert('Car detail saved successfully!');
//             console.log(response.data);
//         } catch (error) {
//             console.error('There was an error saving the car detail!', error.response || error);
//             alert('Error saving car detail!');
//         }
//     };
    

//     return (
//         <Box
//             sx={{
//                 maxWidth: 600,
//                 margin: 'auto',
//                 padding: 3,
//                 borderRadius: 2,
//                 boxShadow: 3,
//                 backgroundColor: 'background.paper'
//             }}
//         >
//             <Typography variant="h4" gutterBottom>
//                 Car Detail Form
//             </Typography>
//             <form onSubmit={handleSubmit}>
//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="Id">ID</InputLabel>
//                     <OutlinedInput
//                         id="Id"
//                         name="Id"
//                         value={carDetail.Id}
//                         onChange={handleChange}
//                         label="ID"
//                     />
//                 </FormControl>

//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="Name">Name</InputLabel>
//                     <OutlinedInput
//                         id="Name"
//                         name="Name"
//                         value={carDetail.Name}
//                         onChange={handleChange}
//                         label="Name"
//                     />
//                 </FormControl>

//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="Manufacturer">Manufacturer</InputLabel>
//                     <OutlinedInput
//                         id="Manufacturer"
//                         name="Manufacturer"
//                         value={carDetail.Manufacturer}
//                         onChange={handleChange}
//                         label="Manufacturer"
//                     />
//                 </FormControl>

//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="Type">Type</InputLabel>
//                     <OutlinedInput
//                         id="Type"
//                         name="Type"
//                         value={carDetail.Type}
//                         onChange={handleChange}
//                         label="Type"
//                     />
//                 </FormControl>

//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="Capacity">Capacity</InputLabel>
//                     <OutlinedInput
//                         id="Capacity"
//                         name="Capacity"
//                         value={carDetail.Capacity}
//                         onChange={handleChange}
//                         label="Capacity"
//                     />
//                 </FormControl>

//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="PerDay">Per Day</InputLabel>
//                     <OutlinedInput
//                         id="PerDay"
//                         name="PerDay"
//                         value={carDetail.PerDay}
//                         onChange={handleChange}
//                         label="Per Day"
//                     />
//                 </FormControl>

//                 <FormControlLabel
//                     control={
//                         <Checkbox
//                             name="IsPopular"
//                             checked={carDetail.IsPopular}
//                             onChange={handleChange}
//                         />
//                     }
//                     label="Is Popular"
//                 />

//                 <FormControlLabel
//                     control={
//                         <Checkbox
//                             name="IsRecommended"
//                             checked={carDetail.IsRecommended}
//                             onChange={handleChange}
//                         />
//                     }
//                     label="Is Recommended"
//                 />

//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="TravelType">Travel Type</InputLabel>
//                     <Select
//                         id="TravelType"
//                         name="TravelType"
//                         multiple
//                         value={carDetail.TravelType}
//                         onChange={handleMultiChange}
//                         renderValue={(selected) => selected.join(', ')}
//                         input={<OutlinedInput label="Travel Type" />}
//                     >
//                         <MenuItem value="SelfDrive">Self Drive</MenuItem>
//                         <MenuItem value="Wedding">Wedding</MenuItem>
//                         <MenuItem value="Tour">Tour</MenuItem>
//                     </Select>
//                 </FormControl>

//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="VehicleType">Vehicle Type</InputLabel>
//                     <Select
//                         id="VehicleType"
//                         name="VehicleType"
//                         multiple
//                         value={carDetail.VehicleType}
//                         onChange={handleMultiChange}
//                         renderValue={(selected) => selected.join(', ')}
//                         input={<OutlinedInput label="Vehicle Type" />}
//                     >
//                         <MenuItem value="Car">Car</MenuItem>
//                         <MenuItem value="Van">Van</MenuItem>
//                         <MenuItem value="Bus">Bus</MenuItem>
//                     </Select>
//                 </FormControl>

//                 <Button variant="contained" color="primary" type="submit">
//                     Save Car Detail
//                 </Button>
//             </form>
//         </Box>
//     );
// };

// export default CarDetailForm;

// import React, { useState } from 'react';
// import axios from 'axios';
// import {
//     Box,
//     FormControl,
//     InputLabel,
//     OutlinedInput,
//     FormControlLabel,
//     Checkbox,
//     Select,
//     MenuItem,
//     Button,
//     Typography,
// } from '@mui/material';

// const CarDetailForm = () => {
//     const [carDetail, setCarDetail] = useState({
//         Id: '',
//         Name: '',
//         Manufacturer: '',
//         Type: '',
//         Capacity: '',
//         PerDay: '',
//         IsPopular: false,
//         IsRecommended: false,
//         TravelType: [],
//         VehicleType: [],
//     });

//     const handleChange = (e) => {
//         const { name, value, type, checked } = e.target;
//         setCarDetail((prevState) => ({
//             ...prevState,
//             [name]: type === 'checkbox' ? checked : value,
//         }));
//     };

//     const handleMultiChange = (e) => {
//         const { name, value } = e.target;
//         setCarDetail((prevState) => ({
//             ...prevState,
//             [name]: typeof value === 'string' ? value.split(',') : value,
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         // Format TravelType and VehicleType as comma-separated strings
//         const formattedCarDetail = {
//             ...carDetail,
//             TravelType: carDetail.TravelType.join(','),
//             VehicleType: carDetail.VehicleType.join(','),
//         };

//         try {
//             const response = await axios.post('https://carrentalbackend.dockyardsoftware.com/api/CarDetail', formattedCarDetail, {
//                 headers: { 'Content-Type': 'application/json' },
//             });
//             alert('Car detail saved successfully!');
//             console.log(response.data);
//         } catch (error) {
//             console.error('There was an error saving the car detail!', error.response?.data || error);
//             alert('Error saving car detail: ' + JSON.stringify(error.response?.data?.errors || {}));
//         }
//     };

//     return (
//         <Box
//             sx={{
//                 maxWidth: 600,
//                 margin: 'auto',
//                 padding: 3,
//                 borderRadius: 2,
//                 boxShadow: 3,
//                 backgroundColor: 'background.paper',
//             }}
//         >
//             <Typography variant="h4" gutterBottom>
//                 Car Detail Form
//             </Typography>
//             <form onSubmit={handleSubmit}>
//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="Id">ID</InputLabel>
//                     <OutlinedInput
//                         id="Id"
//                         name="Id"
//                         value={carDetail.Id}
//                         onChange={handleChange}
//                         label="ID"
//                     />
//                 </FormControl>

//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="Name">Name</InputLabel>
//                     <OutlinedInput
//                         id="Name"
//                         name="Name"
//                         value={carDetail.Name}
//                         onChange={handleChange}
//                         label="Name"
//                     />
//                 </FormControl>

//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="Manufacturer">Manufacturer</InputLabel>
//                     <OutlinedInput
//                         id="Manufacturer"
//                         name="Manufacturer"
//                         value={carDetail.Manufacturer}
//                         onChange={handleChange}
//                         label="Manufacturer"
//                     />
//                 </FormControl>

//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="Type">Type</InputLabel>
//                     <OutlinedInput
//                         id="Type"
//                         name="Type"
//                         value={carDetail.Type}
//                         onChange={handleChange}
//                         label="Type"
//                     />
//                 </FormControl>

//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="Capacity">Capacity</InputLabel>
//                     <OutlinedInput
//                         id="Capacity"
//                         name="Capacity"
//                         value={carDetail.Capacity}
//                         onChange={handleChange}
//                         label="Capacity"
//                     />
//                 </FormControl>

//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="PerDay">Per Day</InputLabel>
//                     <OutlinedInput
//                         id="PerDay"
//                         name="PerDay"
//                         value={carDetail.PerDay}
//                         onChange={handleChange}
//                         label="Per Day"
//                     />
//                 </FormControl>

//                 <FormControlLabel
//                     control={
//                         <Checkbox
//                             name="IsPopular"
//                             checked={carDetail.IsPopular}
//                             onChange={handleChange}
//                         />
//                     }
//                     label="Is Popular"
//                 />

//                 <FormControlLabel
//                     control={
//                         <Checkbox
//                             name="IsRecommended"
//                             checked={carDetail.IsRecommended}
//                             onChange={handleChange}
//                         />
//                     }
//                     label="Is Recommended"
//                 />

//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="TravelType">Travel Type</InputLabel>
//                     <Select
//                         id="TravelType"
//                         name="TravelType"
//                         multiple
//                         value={carDetail.TravelType}
//                         onChange={handleMultiChange}
//                         renderValue={(selected) => selected.join(', ')}
//                         input={<OutlinedInput label="Travel Type" />}
//                     >
//                         <MenuItem value="SelfDrive">Self Drive</MenuItem>
//                         <MenuItem value="Wedding">Wedding</MenuItem>
//                         <MenuItem value="Tour">Tour</MenuItem>
//                     </Select>
//                 </FormControl>

//                 <FormControl fullWidth sx={{ mb: 2 }} variant="outlined">
//                     <InputLabel htmlFor="VehicleType">Vehicle Type</InputLabel>
//                     <Select
//                         id="VehicleType"
//                         name="VehicleType"
//                         multiple
//                         value={carDetail.VehicleType}
//                         onChange={handleMultiChange}
//                         renderValue={(selected) => selected.join(', ')}
//                         input={<OutlinedInput label="Vehicle Type" />}
//                     >
//                         <MenuItem value="Car">Car</MenuItem>
//                         <MenuItem value="Van">Van</MenuItem>
//                         <MenuItem value="Bus">Bus</MenuItem>
//                     </Select>
//                 </FormControl>

//                 <Button variant="contained" color="primary" type="submit">
//                     Save Car Detail
//                 </Button>
//             </form>
//         </Box>
//     );
// };

// export default CarDetailForm;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// function ManufacturerManager() {
//   const [manufacturers, setManufacturers] = useState([]);
//   const [name, setName] = useState('');
//   const [availabilityCount, setAvailabilityCount] = useState(0);
//   const [selectedManufacturerId, setSelectedManufacturerId] = useState(null);
//   const [isEditMode, setIsEditMode] = useState(false);

//   // Fetch manufacturers
//   useEffect(() => {
//     async function fetchManufacturers() {
//       try {
//         const response = await axios.get('https://carrentalbackend.dockyardsoftware.com/api/Manufacturer');
//         setManufacturers(response.data);
//       } catch (error) {
//         console.error('Error fetching manufacturers:', error);
//       }
//     }
//     fetchManufacturers();
//   }, []);

//   const handleCreate = async (e) => {
//     e.preventDefault();
//     const manufacturer = { name, availabilityCount }; // Ensure availabilityCount is an integer

//     // Validate input
//     if (!name || availabilityCount < 0) {
//       console.error('Invalid input: Name is required and Availability Count must be non-negative.');
//       return;
//     }

//     try {
//       const response = await axios.post('https://carrentalbackend.dockyardsoftware.com/api/Manufacturer', manufacturer);
//       setManufacturers([...manufacturers, response.data]);
//       setName('');
//       setAvailabilityCount(0);
//     } catch (error) {
//       console.error('Error creating manufacturer:', error.response ? error.response.data : error.message);
//     }
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     const updatedManufacturer = { manufacturerId: selectedManufacturerId, name, availabilityCount: parseInt(availabilityCount, 10) };

//     try {
//       await axios.put(`https://carrentalbackend.dockyardsoftware.com/api/Manufacturer/${selectedManufacturerId}`, updatedManufacturer);
//       setManufacturers(manufacturers.map((manufacturer) =>
//         manufacturer.manufacturerId === selectedManufacturerId ? { ...manufacturer, name, availabilityCount } : manufacturer
//       ));
//       setIsEditMode(false);
//       setName('');
//       setAvailabilityCount(0);
//       setSelectedManufacturerId(null);
//     } catch (error) {
//       console.error('Error updating manufacturer:', error);
//     }
//   };

//   const handleEdit = (manufacturer) => {
//     setSelectedManufacturerId(manufacturer.manufacturerId);
//     setName(manufacturer.name);
//     setAvailabilityCount(manufacturer.availabilityCount);
//     setIsEditMode(true);
//   };

//   const handleDelete = async (id) => {
//     try {
//       await axios.delete(`https://carrentalbackend.dockyardsoftware.com/api/Manufacturer/${id}`);
//       setManufacturers(manufacturers.filter((manufacturer) => manufacturer.manufacturerId !== id));
//     } catch (error) {
//       console.error('Error deleting manufacturer:', error);
//     }
//   };

//   const handleAvailabilityUpdate = async (id, newCount) => {
//     try {
//       await axios.patch(`https://carrentalbackend.dockyardsoftware.com/api/Manufacturer/UpdateAvailability/${id}`, newCount);
//       setManufacturers(manufacturers.map((manufacturer) =>
//         manufacturer.manufacturerId === id ? { ...manufacturer, availabilityCount: newCount } : manufacturer
//       ));
//     } catch (error) {
//       console.error('Error updating availability:', error);
//     }
//   };

//   return (
//     <div className="container mx-auto p-4">
//       <h1 className="text-3xl font-bold text-center mb-6">Manufacturer Management</h1>

//       {/* Create or Update Manufacturer Form */}
//       <form onSubmit={isEditMode ? handleUpdate : handleCreate} className="bg-white p-6 rounded-lg shadow-md max-w-lg mx-auto">
//         <div className="mb-4">
//           <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
//           <input
//             type="text"
//             id="name"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             required
//             className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
//           />
//         </div>
//         <div className="mb-4">
//           <label htmlFor="availabilityCount" className="block text-sm font-medium text-gray-700">Availability Count</label>
//           <input
//             type="number"
//             id="availabilityCount"
//             value={availabilityCount}
//             onChange={(e) => setAvailabilityCount(e.target.value)}
//             required
//             min="0" // Ensure the value is non-negative
//             className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
//           />
//         </div>
//         <button type="submit" className="w-full bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600 focus:outline-none">
//           {isEditMode ? 'Update Manufacturer' : 'Create Manufacturer'}
//         </button>
//       </form>

//       {/* Manufacturer List */}
//       <h2 className="text-2xl font-semibold mt-8 mb-4">Manufacturer List</h2>
//       <ul className="space-y-4">
//         {manufacturers.map((manufacturer) => (
//           <li key={manufacturer.manufacturerId} className="bg-white p-4 rounded-lg shadow-md flex justify-between items-center">
//             <div>
//               <strong className="text-xl">{manufacturer.name}</strong> 
//               <p>Availability: {manufacturer.availabilityCount}</p>
//             </div>
//             <div className="flex space-x-2">
//               <button
//                 onClick={() => handleEdit(manufacturer)}
//                 className="bg-yellow-500 text-white p-2 rounded-md hover:bg-yellow-600"
//               >
//                 Edit
//               </button>
//               <button
//                 onClick={() => handleDelete(manufacturer.manufacturerId)}
//                 className="bg-red-500 text-white p-2 rounded-md hover:bg-red-600"
//               >
//                 Delete
//               </button>
//               <button
//                 onClick={() => handleAvailabilityUpdate(manufacturer.manufacturerId, manufacturer.availabilityCount + 1)}
//                 className="bg-green-500 text-white p-2 rounded-md hover:bg-green-600"
//               >
//                 Increase Availability
//               </button>
//               <button
//                 onClick={() => handleAvailabilityUpdate(manufacturer.manufacturerId, manufacturer.availabilityCount - 1)}
//                 className="bg-gray-500 text-white p-2 rounded-md hover:bg-gray-600"
//               >
//                 Decrease Availability
//               </button>
//             </div>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }

// export default ManufacturerManager;



// import { useState, useEffect } from 'react';

// const ManufacturerComponent = () => {
//     const [manufacturers, setManufacturers] = useState([]);
//     const [newManufacturer, setNewManufacturer] = useState({ name: '', availabilityCount: 0 });
//     const [availabilityCount, setAvailabilityCount] = useState(0);

//     // Fetch manufacturers list
//     useEffect(() => {
//         fetch('https://carrentalbackend.dockyardsoftware.com/api/Manufacturer')
//             .then(response => response.json())
//             .then(data => setManufacturers(data));
//     }, []);

//     const handleCreateManufacturer = async (e) => {
//         e.preventDefault();
    
//         const manufacturerData = {
//             name: newManufacturer.name.trim(), // Ensure name is not empty
//             availabilityCount: newManufacturer.availabilityCount || 0 // Default to 0
//         };
    
//         const response = await fetch('https://carrentalbackend.dockyardsoftware.com/api/Manufacturer', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify(manufacturerData)
//         });
    
//         if (response.ok) {
//             const createdManufacturer = await response.json();
//             setManufacturers((prev) => [...prev, createdManufacturer]);
//             setNewManufacturer({ name: '', availabilityCount: 0 });
//         } else {
//             const errorData = await response.json();
//             console.error('Error:', errorData);
//         }
//     };
    
    
    
//     const handleUpdateAvailability = async (id) => {
//         const response = await fetch(`/api/Manufacturer/UpdateAvailability/${id}`, {
//             method: 'PATCH',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify(availabilityCount),
//         });

//         if (response.ok) {
//             const updatedManufacturer = await response.json();
//             setManufacturers((prev) =>
//                 prev.map((manufacturer) =>
//                     manufacturer.manufacturerId === id
//                         ? { ...manufacturer, availabilityCount: availabilityCount }
//                         : manufacturer
//                 )
//             );
//             setAvailabilityCount(0);
//         }
//     };

//     return (
//         <div className="container mx-auto p-6">
//             <h1 className="text-2xl font-bold text-center mb-4">Manufacturers</h1>
            
//             {/* Manufacturer Create Form */}
//             <div className="mb-6">
//                 <h2 className="text-xl font-semibold mb-3">Create Manufacturer</h2>
//                 <form onSubmit={handleCreateManufacturer} className="space-y-4">
//                     <input
//                         type="text"
//                         placeholder="Manufacturer Name"
//                         value={newManufacturer.name}
//                         onChange={(e) => setNewManufacturer({ ...newManufacturer, name: e.target.value })}
//                         className="w-full px-4 py-2 border rounded-md"
//                     />
//                     <input
//                         type="number"
//                         placeholder="Availability Count"
//                         value={newManufacturer.availabilityCount}
//                         onChange={(e) =>
//                             setNewManufacturer({
//                                 ...newManufacturer,
//                                 availabilityCount: parseInt(e.target.value, 10),
//                             })
//                         }
//                         className="w-full px-4 py-2 border rounded-md"
//                     />
//                     <button
//                         type="submit"
//                         className="w-full py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
//                     >
//                         Create Manufacturer
//                     </button>
//                 </form>
//             </div>

//             {/* Manufacturer List */}
//             <h2 className="text-xl font-semibold mb-3">Existing Manufacturers</h2>
//             <ul className="space-y-4">
//                 {manufacturers.map((manufacturer) => (
//                     <li key={manufacturer.manufacturerId} className="flex justify-between items-center bg-gray-100 p-4 rounded-md">
//                         <div>
//                             <h3 className="font-medium">{manufacturer.name}</h3>
//                             <p>Availability: {manufacturer.availabilityCount}</p>
//                         </div>
//                         <div>
//                             <input
//                                 type="number"
//                                 value={availabilityCount}
//                                 onChange={(e) => setAvailabilityCount(parseInt(e.target.value, 10))}
//                                 className="px-4 py-2 border rounded-md"
//                             />
//                             <button
//                                 onClick={() => handleUpdateAvailability(manufacturer.manufacturerId)}
//                                 className="ml-4 py-2 px-4 bg-green-500 text-white rounded-md hover:bg-green-600"
//                             >
//                                 Update Availability
//                             </button>
//                         </div>
//                     </li>
//                 ))}
//             </ul>
//         </div>
//     );
// };

// export default ManufacturerComponent;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// function ManufacturerManager() {
//   const [manufacturers, setManufacturers] = useState([]);
//   const [name, setName] = useState('');
//   const [selectedManufacturerId, setSelectedManufacturerId] = useState(null);
//   const [isEditMode, setIsEditMode] = useState(false);

//   // Fetch manufacturers
//   useEffect(() => {
//     async function fetchManufacturers() {
//       try {
//         const response = await axios.get('https://carrentalbackend.dockyardsoftware.com/api/Manufacturer');
//         setManufacturers(response.data);
//       } catch (error) {
//         console.error('Error fetching manufacturers:', error);
//       }
//     }
//     fetchManufacturers();
//   }, []);

//   const handleCreate = async (e) => {
//     e.preventDefault();
//     const manufacturer = { name }; // Only include the name for creation

//     // Validate input
//     if (!name) {
//       console.error('Invalid input: Name is required.');
//       return;
//     }

//     try {
//       // Automatically set the availabilityCount as 0 or based on the car count for this manufacturer
//       const response = await axios.post('https://carrentalbackend.dockyardsoftware.com/api/Manufacturer', manufacturer);
//       setManufacturers([...manufacturers, response.data]);
//       setName('');
//     } catch (error) {
//       console.error('Error creating manufacturer:', error.response ? error.response.data : error.message);
//     }
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     const updatedManufacturer = { manufacturerId: selectedManufacturerId, name };

//     try {
//       await axios.put(`https://carrentalbackend.dockyardsoftware.com/api/Manufacturer/${selectedManufacturerId}`, updatedManufacturer);
//       setManufacturers(manufacturers.map((manufacturer) =>
//         manufacturer.manufacturerId === selectedManufacturerId ? { ...manufacturer, name } : manufacturer
//       ));
//       setIsEditMode(false);
//       setName('');
//       setSelectedManufacturerId(null);
//     } catch (error) {
//       console.error('Error updating manufacturer:', error);
//     }
//   };

//   const handleEdit = (manufacturer) => {
//     setSelectedManufacturerId(manufacturer.manufacturerId);
//     setName(manufacturer.name);
//     setIsEditMode(true);
//   };

//   const handleDelete = async (id) => {
//     try {
//       await axios.delete(`https://carrentalbackend.dockyardsoftware.com/api/Manufacturer/${id}`);
//       setManufacturers(manufacturers.filter((manufacturer) => manufacturer.manufacturerId !== id));
//     } catch (error) {
//       console.error('Error deleting manufacturer:', error);
//     }
//   };

//   const handleAvailabilityUpdate = async (id, newCount) => {
//     try {
//       await axios.patch(`https://carrentalbackend.dockyardsoftware.com/api/Manufacturer/UpdateAvailability/${id}`, newCount);
//       setManufacturers(manufacturers.map((manufacturer) =>
//         manufacturer.manufacturerId === id ? { ...manufacturer, availabilityCount: newCount } : manufacturer
//       ));
//     } catch (error) {
//       console.error('Error updating availability:', error);
//     }
//   };

//   return (
//     <div className="container mx-auto p-4">
//       <h1 className="text-3xl font-bold text-center mb-6">Manufacturer Management</h1>

//       {/* Create or Update Manufacturer Form */}
//       <form onSubmit={isEditMode ? handleUpdate : handleCreate} className="bg-white p-6 rounded-lg shadow-md max-w-lg mx-auto">
//         <div className="mb-4">
//           <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
//           <input
//             type="text"
//             id="name"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             required
//             className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
//           />
//         </div>
//         <button type="submit" className="w-full bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600 focus:outline-none">
//           {isEditMode ? 'Update Manufacturer' : 'Create Manufacturer'}
//         </button>
//       </form>

//       {/* Manufacturer List */}
//       <h2 className="text-2xl font-semibold mt-8 mb-4">Manufacturer List</h2>
//       <ul className="space-y-4">
//         {manufacturers.map((manufacturer) => (
//           <li key={manufacturer.manufacturerId} className="bg-white p-4 rounded-lg shadow-md flex justify-between items-center">
//             <div>
//               <strong className="text-xl">{manufacturer.name}</strong>
//               <p>Availability: {manufacturer.availabilityCount}</p>
//             </div>
//             <div className="flex space-x-2">
//               <button
//                 onClick={() => handleEdit(manufacturer)}
//                 className="bg-yellow-500 text-white p-2 rounded-md hover:bg-yellow-600"
//               >
//                 Edit
//               </button>
//               <button
//                 onClick={() => handleDelete(manufacturer.manufacturerId)}
//                 className="bg-red-500 text-white p-2 rounded-md hover:bg-red-600"
//               >
//                 Delete
//               </button>
//               <button
//                 onClick={() => handleAvailabilityUpdate(manufacturer.manufacturerId, manufacturer.availabilityCount + 1)}
//                 className="bg-green-500 text-white p-2 rounded-md hover:bg-green-600"
//               >
//                 Increase Availability
//               </button>
//               <button
//                 onClick={() => handleAvailabilityUpdate(manufacturer.manufacturerId, manufacturer.availabilityCount - 1)}
//                 className="bg-gray-500 text-white p-2 rounded-md hover:bg-gray-600"
//               >
//                 Decrease Availability
//               </button>
//             </div>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }

// export default ManufacturerManager;


import React, { useState, useEffect } from 'react';
import axios from 'axios';

function ManufacturerManager() {
  const [manufacturers, setManufacturers] = useState([]);
  const [name, setName] = useState('');
  const [selectedManufacturerId, setSelectedManufacturerId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');  // <-- error message state

  // Fetch manufacturers
  useEffect(() => {
    async function fetchManufacturers() {
      try {
        const response = await axios.get('https://carrentalbackend.dockyardsoftware.com/api/Manufacturer');
        setManufacturers(response.data);
      } catch (error) {
        console.error('Error fetching manufacturers:', error);
      }
    }
    fetchManufacturers();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    const manufacturer = { name };

    if (!name.trim()) {
      setErrorMessage('Name is required.');
      return;
    }

    try {
      const response = await axios.post('https://carrentalbackend.dockyardsoftware.com/api/Manufacturer', manufacturer);
      setManufacturers([...manufacturers, response.data]);
      setName('');
      setErrorMessage(''); // clear error on success
    } catch (error) {
      // Extract backend error message if exists
      if (error.response?.data?.error) {
        setErrorMessage(error.response.data.error);
      } else {
        setErrorMessage('Error creating manufacturer.');
      }
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const updatedManufacturer = { manufacturerId: selectedManufacturerId, name };

    if (!name.trim()) {
      setErrorMessage('Name is required.');
      return;
    }

    try {
      await axios.put(`https://carrentalbackend.dockyardsoftware.com/api/Manufacturer/${selectedManufacturerId}`, updatedManufacturer);
      setManufacturers(manufacturers.map((manufacturer) =>
        manufacturer.manufacturerId === selectedManufacturerId ? { ...manufacturer, name } : manufacturer
      ));
      setIsEditMode(false);
      setName('');
      setSelectedManufacturerId(null);
      setErrorMessage(''); // clear error on success
    } catch (error) {
      if (error.response?.data?.error) {
        setErrorMessage(error.response.data.error);
      } else {
        setErrorMessage('Error updating manufacturer.');
      }
    }
  };

  const handleEdit = (manufacturer) => {
    setSelectedManufacturerId(manufacturer.manufacturerId);
    setName(manufacturer.name);
    setErrorMessage('');
    setIsEditMode(true);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://carrentalbackend.dockyardsoftware.com/api/Manufacturer/${id}`);
      setManufacturers(manufacturers.filter((manufacturer) => manufacturer.manufacturerId !== id));
      setErrorMessage('');
    } catch (error) {
      console.error('Error deleting manufacturer:', error);
    }
  };

  const handleAvailabilityUpdate = async (id, newCount) => {
    try {
      await axios.patch(`https://carrentalbackend.dockyardsoftware.com/api/Manufacturer/UpdateAvailability/${id}`, newCount);
      setManufacturers(manufacturers.map((manufacturer) =>
        manufacturer.manufacturerId === id ? { ...manufacturer, availabilityCount: newCount } : manufacturer
      ));
      setErrorMessage('');
    } catch (error) {
      console.error('Error updating availability:', error);
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold text-center mb-6">Manufacturer Management</h1>

      {/* Create or Update Manufacturer Form */}
      <form onSubmit={isEditMode ? handleUpdate : handleCreate} className="bg-white p-6 rounded-lg shadow-md max-w-lg mx-auto">
        <div className="mb-4">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setErrorMessage(''); // Clear error when user starts typing
            }}
            required
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
          />
          {/* Show error message here */}
          {errorMessage && (
            <p className="text-red-600 mt-2">{errorMessage}</p>
          )}
        </div>
        <button
          type="submit"
          className="w-full bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600 focus:outline-none"
        >
          {isEditMode ? 'Update Manufacturer' : 'Create Manufacturer'}
        </button>
      </form>

      {/* Manufacturer List */}
      <h2 className="text-2xl font-semibold mt-8 mb-4">Manufacturer List</h2>
      <ul className="space-y-4">
        {manufacturers.map((manufacturer) => (
          <li key={manufacturer.manufacturerId} className="bg-white p-4 rounded-lg shadow-md flex justify-between items-center">
            <div>
              <strong className="text-xl">{manufacturer.name}</strong>
              <p>Availability: {manufacturer.availabilityCount}</p>
            </div>
            <div className="flex space-x-2">
              <button
                onClick={() => handleEdit(manufacturer)}
                className="bg-yellow-500 text-white p-2 rounded-md hover:bg-yellow-600"
              >
                Edit
              </button>
              <button
                onClick={() => handleDelete(manufacturer.manufacturerId)}
                className="bg-red-500 text-white p-2 rounded-md hover:bg-red-600"
              >
                Delete
              </button>
              <button
                onClick={() => handleAvailabilityUpdate(manufacturer.manufacturerId, manufacturer.availabilityCount + 1)}
                className="bg-green-500 text-white p-2 rounded-md hover:bg-green-600"
              >
                Increase Availability
              </button>
              <button
                onClick={() => handleAvailabilityUpdate(manufacturer.manufacturerId, manufacturer.availabilityCount - 1)}
                className="bg-gray-500 text-white p-2 rounded-md hover:bg-gray-600"
              >
                Decrease Availability
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ManufacturerManager;
